<template>
  <div class="page">
    <div id="documentoParaAssinar" style="padding-left: 5px"></div>
    <filiacaoLiberada ref="filiacaoModal" />
    <documentacaoPendente ref="documentacaoModal" />
  </div>
</template>


<script>
import store from "@/store";
import filiacaoLiberada from "@/components/assinaturaEletronica/filiacaoLiberada";
import documentacaoPendente from "@/components/assinaturaEletronica/documentacaoPendente";

export default {
  data() {
    return {
      loading: true,
      showFilters: false,
      showModal: false,
      urlDocumento: "",
    };
  },

  created() {
    this.montaDocumentoAssinaturaEletronica();
  },

  components: { filiacaoLiberada, documentacaoPendente },

  methods: {
    montaDocumentoAssinaturaEletronica() {
      this.loading = true;
      this.$http
        .get("api/assinaturaEletronica/verificarPendenciaAssinaturaEletronica")
        .then(async (response) => {
          const data = response.data[0];
          const assinaturaEletronica = store.state.assinaturaEletronica;
          // const aceiteFiliacao = store.state.aceiteFiliacao;

          // Verifica se existe documento a ser assinado, se não existe, ele continua o fluxo normal, se existe, ele redireciona para a tela de assinatura
          if (response.data.length > 0) {
            if (
              data.TIPOPENDENCIA == "S" &&
              data.SQUPLOADPENDENCIA !== null &&
              assinaturaEletronica == false
            ) {
              if (data.SQTIPOANEXOPENDENCIA == 64) {
                // if (!aceiteFiliacao) {
                await this.abrirModalFiliacao();
                // }
              } else {
                await this.abrirModalDocumentoPendente();
              }

              await this.getUrlDocumento(data.SQUPLOADPENDENCIA);

              const iframe = document.createElement("iframe");
              iframe.src = this.urlDocumento;
              iframe.className = "iframeAssinaDocumento";
              iframe.style.width = "80vw";
              iframe.style.height = "calc(100vh - 240px)";
              document
                .getElementById("documentoParaAssinar")
                .appendChild(iframe);
            } else {
              this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
              this.$router.push("/");
            }
          } else {
            this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
            this.$router.push("/");
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },

    async abrirModalFiliacao() {
      this.$refs.filiacaoModal.abrirModal();
    },

    async abrirModalDocumentoPendente() {
      this.$refs.documentacaoModal.abrirModal();
    },

    async getUrlDocumento(sq_upload) {
      try {
        const response = await this.$http.get(
          "api/assinaturaEletronica/getUrlDocumento/" + sq_upload
        );
        if (response.data.IsValid === true) {
          this.urlDocumento = response.data.Data;
        } else {
          this.$tools.alerta(
            "Não foi encontrado o documento para assinatura. Entre em contato com a Unicampo [1]!",
            "warning"
          );

          //REVISAR
          this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
          this.$router.push("/");
        }
      } catch (error) {
        console.error(error.data.Message);
        this.$tools.alerta(
          "Não foi encontrado o documento para assinatura. Entre em contato com a Unicampo [2]!",
          "warning"
        );
        this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
        this.$router.push("/");
      }
    },
  },
};
</script>